import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "../../supabase";
import LoadingScreen from "../LoadingScreen";

export default function AdminGuard({ children }) {
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    supabase.auth.getSession().then(async ({ data: { session } }) => {
      if (!session) { setStatus("denied"); return; }
      const { data } = await supabase
        .from("profiles")
        .select("is_admin")
        .eq("id", session.user.id)
        .single();
      setStatus(data?.is_admin ? "allowed" : "denied");
    });
  }, []);

  if (status === "loading") return <LoadingScreen />;
  if (status === "denied") return <Navigate to="/" replace />;
  return children;
}
